<template>
  <div class="photo-wall-container">
    <!-- 照片墙上传组件 -->
    <el-upload
      v-if="editable"
      :action="$uploadImg"
      :data="recruitUploadData"
      :headers="recruitUploadHeader"
      list-type="picture-card"
      :file-list="photoList"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :on-success="handleSuccess"
      :before-upload="beforeUpload"
      :limit="maxCount"
      :on-exceed="handleExceed"
      :multiple="false"
      :disabled="uploading"
      accept="image/*"
      class="photo-uploader"
    >
      <i class="el-icon-plus"></i>
      <!-- <div slot="tip" class="el-upload__tip">
        只能上传jpg/png文件，单张不超过2MB，最多{{ maxCount }}张
      </div> -->
    </el-upload>

    <!-- 只读模式显示照片墙 -->
    <div v-else class="photo-wall-readonly">
      <div v-if="!photoList.length" style="font-size:10px;color:#606266">未上传</div>
      <div
        v-else
        v-for="(photo, index) in photoList"
        :key="index"
        class="photo-card"
      >
        <el-image 
          class="view-image"
          :preview-src-list="[photo.url]"
          :src="photo.url" >
        </el-image>
        <!-- <img :src="photo.url" class="photo-img" /> -->
      </div>
    </div>

    <!-- 图片预览对话框 -->
    <el-dialog :visible.sync="previewVisible" append-to-body>
      <img :src="previewImageUrl" style="width: 100%" />
    </el-dialog>
  </div>
</template>

<script>
import base from "./../js/base";

export default {
  mixins: [base],
  name: "PhotoWallUpload",
  props: {
    // 初始图片列表（编辑模式回显用）
    initialPhotos: {
      type: Array,
      default: () => [],
    },
    // 是否可编辑
    editable: {
      type: Boolean,
      default: true,
    },
    // 最大上传数量
    maxCount: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      photoList: [], // 当前图片列表
      uploading: false, // 上传中状态
      previewVisible: false, // 预览对话框
      previewImageUrl: "", // 预览图片URL
    };
  },
  watch: {
    // 监听初始图片变化
    initialPhotos: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.photoList = newVal.map((item) => ({
            name: item.name || `photo_${Date.now()}`,
            url: item.url || item,
            status: "success", // 标记为已上传成功
          }));
        }
      },
    },
  },
  methods: {
    // 上传前的校验
    beforeUpload(file) {
      const isImage = file.type.includes("image/");
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isImage) {
        this.$message.error("只能上传图片文件!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("图片大小不能超过 2MB!");
        return false;
      }

      this.uploading = true;
      return true;
    },

    // 上传成功处理
    handleSuccess(response, file, fileList) {
      this.uploading = false;
      let fileId = response.data.fileId + '.' + response.data.ext;
      if (response.result.isSuccess === true) {
        // 根据实际API响应调整
        // 更新图片列表
        this.photoList = fileList.map((item) => {
          if (item.response) {
            return {
              url: item.url,
              name: fileId,
              status: "success",
            };
          }
          return item;
        });
        this.$message.success("上传成功");
        this.$emit("change", this.getPhotoUrls()); // 通知父组件变化
      } else {
        this.$message.error(response.message || "上传失败");
      }
    },

    // 移除图片处理
    handleRemove(file, fileList) {
      this.photoList = fileList;
      this.$emit("change", this.getPhotoUrls()); // 通知父组件变化
      this.$message.success("删除成功");
    },

    // 图片预览
    handlePreview(file) {
      this.previewImageUrl = file.url;
      this.previewVisible = true;
    },

    // 超出限制提示
    handleExceed() {
      this.$message.warning(`最多只能上传 ${this.maxCount} 张图片`);
    },

    // 获取当前所有图片URL（供父组件使用）
    getPhotoUrls() {
      return this.photoList
        .filter((item) => item.status === "success")
        .map((item) => ({
          url: item.url,
          name: item.name,
        }));
    },

    // 手动清空照片墙
    clearFiles() {
      this.photoList = [];
      this.$emit("change", []);
    },
  },
};
</script>

<style scoped>
.photo-wall-container {
  margin: 20px 0;
}

/* 上传组件样式 */
.photo-uploader ::v-deep .el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 100px;
}

.photo-uploader ::v-deep .el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
}

/* 只读模式照片墙样式 */
.photo-wall-readonly {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.photo-card {
  width: 146px;
  height: 146px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  overflow: hidden;
  position: relative;
  transition: border-color 0.3s;
}

.photo-card:hover {
  border-color: #409eff;
}

.photo-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/pages/recruit/officeSaff/component/photoWallUpload.vue